import * as React from 'react';
import { Link } from 'react-router-dom';
import MyAccountHeaderComponent from 'src/modules/my-account/partials/MyAccountHeader.component';
import InvestorType from 'src/entities/InvestorType';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import Person from 'src/entities/Person';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';

export interface ConfirmAccreditedInvestorTypeComponentProps {
  investorType: InvestorType;
  handleChange: (value: string) => void;
  handleSubmit: () => void;
  success: boolean;
  activeProfile: Person;
  errorMessage: {};
}

class ConfirmAccreditedInvestorTypeComponent extends React.PureComponent<ConfirmAccreditedInvestorTypeComponentProps> {

  public render(): React.ReactNode {

    return (
      <section className="cuenta-inversor-section">
        <div className="container">
          <MyAccountHeaderComponent
            pageTitle="Mi cuenta"
            breadcrum="Tipo de inversor"
          />
          <div className="row">
            <div className="col-sm-12">
              <div className="simple-card padding-40">
                <section>
                  <Link to="/mi-cuenta/tipo-de-inversor">
                    <span className="close pointer"/>
                  </Link>
                  <div className="gap-20"/>
                  {this.props.success ?
                    <section>
                      <p className="featured c-black-text">
                        <span className="user-circle"/>
                        Acreditate como inversor
                      </p>
                      <div className="row">
                        <div className="text-center col-md-8 col-md-offset-2">
                          <span className="corrected-circle"/>
                          <div className="gap-20"/>
                          <p className="featured c-primary">
                            Muchas gracias por confirmar la solicitud
                          </p>
                          <p>
                            <strong>
                              {this.props.activeProfile.displayName} ahora puedes invertir como
                              Inversor {this.props.investorType.type}
                            </strong>
                          </p>
                          <div className="gap-20"/>
                        </div>
                      </div>
                      <p className="text-center">
                        <Link to="/invertir">
                          <button className="btn btn-secondary btn-lg">
                            Ver las oportunidades de inversión
                          </button>
                        </Link>
                      </p>
                    </section> :
                    <section>
                      <p className="featured c-black-text">
                        <span className="user-circle"/>
                        Acreditate como inversor
                      </p>
                      <div className="gap-20"/>
                      <p>
                        Declaro que he sido advertido que al ser considerado&nbsp;
                        <strong>
                          INVERSOR ACREDITADO&nbsp;
                        </strong>
                        estoy expuesto a mayores riesgos y gozo de menor protección respecto a la inversión en una
                        operación de financiación participativa.
                      </p>
                      <div className="gap-20"/>
                      <p>
                        Para estar seguros de que estás solicitando ser inversor acreditado, te pedimos
                        que escribas en mayúsculas en el espacio de abajo:
                      </p>
                      <p className="featured c-primary text-center">
                        SOLICITO SER INVERSOR ACREDITADO
                      </p>
                      <div className="gap-20"/>
                      <div className="row">
                        <div className="col-sm-6 col-sm-offset-3 text-center">
                          <div className="form-control confirmation b-primary-dark">
                            <InputContainer
                              label=" "
                              type="text"
                              required={false}
                              value={this.props.investorType.confirmationMessage}
                              onChange={this.props.handleChange}
                            />
                          </div>
                          <div className="gap-20"/>
                          <button
                            className="btn btn-secondary btn-lg"
                            onClick={this.props.handleSubmit}
                          >
                            Confirmo mi solicitud
                          </button>
                          <div className="gap-50"/>
                          <ErrorMessagesComponent errorMessage={this.props.errorMessage}/>
                        </div>
                      </div>
                    </section>
                  }
                </section>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ConfirmAccreditedInvestorTypeComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/investor-types/partials/ConfirmAccreditedInvestorType.component.tsx